import React from 'react';

// Styles & Assets
import styles from './PatientInfoText.module.css';

// Interface
interface Props {
    label: string,
    element: string | JSX.Element
}

const PatientInfoText: React.FC<Props> = ({ label, element }) => {


    const renderPatientText = (text: string) => {
        return (text === undefined || text === '') ? '-' : text.toString();
    };


    return (
        <div className={styles.textGeneralInfo}>
            <span><strong>{label}:</strong>{' '}</span>
            {typeof element === 'string' ?
                <p className={styles.text} title={element}>{renderPatientText(element)}</p>
                :
                element
            }
        </div>
    );
};

export default PatientInfoText;